import { render, staticRenderFns } from "./ChangeOrderAddress.vue?vue&type=template&id=b8c5e790&scoped=true"
import script from "./ChangeOrderAddress.vue?vue&type=script&lang=js"
export * from "./ChangeOrderAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c5e790",
  null
  
)

export default component.exports